import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconLightBulb = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.0358 24.5057V24.3283L14.9748 24.1618C14.5343 22.959 13.8646 21.8824 13.2372 20.8996C13.1869 20.8209 13.1369 20.7427 13.0873 20.6652C12.4996 19.7467 11.9621 18.9067 11.5682 18.0085C11.2485 17.2797 11.0716 16.4782 11.0716 15.6348C11.0716 12.2965 13.8712 9.53815 17.3901 9.53815C20.9089 9.53815 23.7085 12.2965 23.7085 15.6348C23.7085 16.4782 23.5316 17.2797 23.2119 18.0085C22.818 18.9067 22.2805 19.7467 21.6928 20.6652C21.6432 20.7427 21.5932 20.8209 21.5429 20.8996C20.9155 21.8824 20.2458 22.959 19.8053 24.1618L19.7443 24.3283V24.5057V27.054H15.0358V24.5057Z" stroke={color} strokeWidth="2"/>
            <path d="M14.3408 31.1034H20.4395" stroke={color} strokeWidth="2"/>
            <path d="M17.3901 6.09872V0" stroke={color} strokeWidth="2"/>
            <path d="M29.5876 17.0764L35.6863 17.0764" stroke={color} strokeWidth="2"/>
            <path d="M0.313698 17.0764L6.41241 17.0764" stroke={color} strokeWidth="2"/>
            <path d="M5.49389 4.57032L9.80634 8.88277" stroke={color} strokeWidth="2"/>
            <path d="M30.5061 4.57032L26.1937 8.88277" stroke={color} strokeWidth="2"/>
        </svg>
    </div>
);

export default IconLightBulb;
